module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/anne-hubspot/anne-hubspot@2x.svg"